// extracted by mini-css-extract-plugin
export default {"container":"NumberInput_container__mwokL","input":"NumberInput_input__v6FiO"};